const _now = new Date();
const _month = _now.getMonth() + 1;
const _year = _now.getFullYear();
const _pad = (n) => String(n).padStart(2, '0');

export const CURRENT_MONTH = _month;
export const CURRENT_YEAR = _year;
export const CURRENT_PERIOD = `${_year}${_pad(_month)}`; // format YYYYMM

export const MONTH_NAMES = [
  '', 'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
  'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember',
];

/** Parse period string "YYYYMM" -> { month, year, label } */
export const parsePeriod = (period) => {
  const year = parseInt(String(period).slice(0, 4));
  const month = parseInt(String(period).slice(4, 6));
  return { year, month, label: `${MONTH_NAMES[month]} ${year}` };
};

// Roles
export const ROLES = {
  SUPERADMIN: 'superadmin',
  ADMIN_COMPANY: 'admin_company',
  EMPLOYEE: 'employee_company',
};

export const ADMIN_ROLES = [ROLES.SUPERADMIN, ROLES.ADMIN_COMPANY];
export const EMPLOYEE_ROLES = [ROLES.EMPLOYEE];

// Report status
export const REPORT_STATUS = {
  DRAFT: 'draft',
  SUBMITTED: 'submitted',
  APPROVED: 'approved',
  REJECTED: 'rejected',
};
